/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SendExpiringContractsToAdminCommand } from '../../models/send-expiring-contracts-to-admin-command';
import { Success } from '../../models/success';

export interface SendExpiringContractsToAdminAsync$Params {
      body?: SendExpiringContractsToAdminCommand
}

export function sendExpiringContractsToAdminAsync(http: HttpClient, rootUrl: string, params?: SendExpiringContractsToAdminAsync$Params, context?: HttpContext): Observable<StrictHttpResponse<Success>> {
  const rb = new RequestBuilder(rootUrl, sendExpiringContractsToAdminAsync.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Success>;
    })
  );
}

sendExpiringContractsToAdminAsync.PATH = '/api/report/admin/expiring-contracts';
